// `/account` (account menu › Account & security): profile, password and signed-in devices for
// every signed-in user, in the plain shell (no company).
import { createRoute } from "@tanstack/react-router";
import { AccountScreen } from "../features/account/account";
import { companiesOf, isOperator } from "../features/company";
import { useSession } from "../features/use-feature";
import { PlainShell } from "../shell/app-shell";
import { authedRoute } from "./_authed";

export const accountRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "account",
  component: function Account() {
    const { api } = accountRoute.useRouteContext();
    const { me } = useSession();
    // The switcher shows the first company (as the picker does); operators see the console.
    const current = isOperator(me) ? null : (companiesOf(me)[0]?.slug ?? null);
    return (
      <PlainShell me={me} api={api} current={current} main="full">
        <AccountScreen api={api} me={me} />
      </PlainShell>
    );
  },
});
